export default __webpack_public_path__ + "static/DEIPage-pattern-large-purple-c68fab5b18e0a67378f684c71fa5b3d3.png";